import classNames from 'classnames';
import Loading from '../Loading';

interface ButtonProperties {
    label?: string;
    symbol?: string;
    onClick?: () => void;
    style?: ButtonStyle;
    isPerformingAction?: boolean,
    isSubmit?: boolean,
    shading?: ButtonShading,
    disabled?: boolean
}

export type ButtonStyle = "primary" | "secondary" | "caution" | "danger" | "disabled";
export type ButtonShading = "solid" | "ghost" | "text";

const Button = function ({
    label,
    symbol,
    onClick,
    style = "primary",
    isSubmit = false,
    isPerformingAction = false,
    shading = "solid",
    disabled = false
}: ButtonProperties) {
    let buttonClasses = classNames({
        "hcs-btn": true,
        "hcs-btn--secondary": style == "secondary",
        "hcs-btn--caution": style === "caution",
        "hcs-btn--danger": style === "danger",
        "hcs-btn--text": shading === "text",
        "hcs-btn--icon": label == undefined && symbol != undefined,
        "hcs-btn--ghost": shading === "ghost"
    });
    let symbolClasses = classNames({
        "fas": true,
        [`fa-${symbol}`]: true,        
        "-ml-2": label != undefined,
        "mr-2": label != undefined
    });

    let submitProps: {type?: "submit"} = {};
    if (isSubmit) {
        submitProps.type = "submit";
    }

    return (
        <button {...submitProps} className={buttonClasses} onClick={onClick} disabled={disabled}>
            <span className="hcs-btn__default">
                {symbol !== undefined && (<Loading isLoading={isPerformingAction} size="sm"><i className={symbolClasses} /></Loading>)}
                {label !== undefined && label}
            </span>
        </button>
    );
}

export default Button;